import DpitAdminTourEdit from './modules/DpitAdminTourEdit';
import DPProPromoButton from './modules/DPProPromoButton';
import DPAcfAdjust from './modules/DPAcfAdjust';


jQuery(document).ready(($) => {
	window.$ = $;
	if (window.dpIntroToursAdminTourEditConfig.dpDebugEn) console.log('[dpit] INIT Admin Tour Edit Config:', window.dpIntroToursAdminTourEditConfig);
	new DPAcfAdjust(window.dpIntroToursAdminTourEditConfig);
	new DPProPromoButton(window.dpIntroToursAdminTourEditConfig);
});

new DpitAdminTourEdit(window.dpIntroToursAdminTourEditConfig);
